import { useEffect, useState } from 'react';
import { Alert, Form } from 'react-bootstrap';
import { createWeblink, updateWeblink } from '../../../../modules/traceability';
import Modal from '../../Modal';
import { Button } from '@mui/material';

const WebLinksModal = ({
  show,
  handleClose,
  entityId,
  entityType,
  fetchAllWebLinks,
  selectedWebLink,
  addNotification,
}) => {
  const defaultWeblink = {
    url: selectedWebLink ? selectedWebLink.url : '',
    description: selectedWebLink ? selectedWebLink.description : '',
  };
  const [weblink, setWeblink] = useState(defaultWeblink);
  const [webLinkValidationError, setWebLinkValidationError] = useState(null)
  const handleChange = (field, value) => {
    setWeblink((prevValue) => ({
      ...prevValue,
      [field]: value,
    }));
  };

  useEffect(() => {
    setWeblink(defaultWeblink);
  }, [selectedWebLink]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const webLinkValidation = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/;
    if (weblink && !weblink.url.match(webLinkValidation)) {
      setWebLinkValidationError('Please add a valid url!.');
      return
    }
    const weblinkData = {
      ...weblink,
      entityId,
      entityType,
    };
    try {
      selectedWebLink
        ? await updateWeblink(selectedWebLink.id, { weblink: weblinkData })
        : await createWeblink({ weblink: weblinkData })

      fetchAllWebLinks();
      handleModalClose();
      addNotification('success', `Weblink ${selectedWebLink ? "updated" : "added"} successfully.`);
      setWeblink(defaultWeblink);
    } catch (error) {
      const errorMessage = 'Failed to add link to the test case.';
      addNotification('danger', errorMessage);
    }
  };

  const handleModalClose = () => {
    setWeblink({
      url: '',
      description: '',
    });
    setWebLinkValidationError(null)
    handleClose();
  };

  return (
    <Modal
      open={show}
      size="md"
      handleClose={handleModalClose}
      modalTitle="Add/Edit web link"
      action={() => <>
        <Button title="Save web link" color="primary" variant="contained" onClick={handleSubmit}>
          Save
        </Button>
        <Button
          title="Close"
          color="secondary"
          variant="outlined"
          onClick={handleModalClose}>
          Close
        </Button>
      </>}>
      <>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="url" className="mb-3">
            <Form.Label>URL</Form.Label>
            <Form.Control
              type="text"
              value={weblink.url}
              placeholder="Enter url"
              required
              onChange={(e) => handleChange('url', e.target.value)}
            />
          </Form.Group>
          <Form.Group controlId="description">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Enter description"
              value={weblink.description}
              onChange={(e) => handleChange('description', e.target.value)}
            />
          </Form.Group>
          {webLinkValidationError && <Alert className='mt-2' variant='danger'>{webLinkValidationError}</Alert>}

        </Form>
      </>
    </Modal>
  );
};

export default WebLinksModal;
